<template>
    <div class="image-upload-container">
      
        <!-- 上传区域 -->
        <div v-if="uploadingImage || imageList.length > 0" class="image-list">
            <div v-for="(image, index) in imageList" 
                :key="index" 
                class="image-item">
                <el-image 
                    :src="image" 
                    fit="cover"
                    class="preview-image">
                </el-image>
                <div class="image-actions">
                    <i class="el-icon-zoom-in delete-btn-icon" @click="showBigImg(image)"></i>
                    <i class="el-icon-delete delete-btn-icon" @click="removeImage(index)"></i>
                    
                    <!-- <el-button 
                        size="mini" 
                        type="danger" 
                        icon="el-icon-delete"
                        @click="removeImage(index)"
                        circle>
                    </el-button> -->
                </div>
            </div>
        <!-- 上传中的图片预览 -->
            <div v-if="uploadingImage" class="uploading-preview">
                <div class="image-item uploading">
                    <el-image 
                        :src="uploadingImage.url" 
                        fit="cover"
                        class="preview-image">
                    </el-image>
                    <div class="uploading-overlay">
                        <i class="el-icon-loading"></i>
                        <span>上传中...</span>
                    </div>
                </div>
            </div>
        </div>
        
        <el-upload
            v-if="!uploadingImage && imageList.length == 0"
            class="upload-demo"
            ref="upload"
            :action="uploadUrl"
            :on-preview="handlePreview"
            :show-file-list="false"
            :on-change="handleChange"
            :before-upload="beforeUpload"
            :on-error="handleUploadError"
            :file-list="[]"
            :auto-upload="true"
            :limit="1"
            :accept="acceptTypes"
            :http-request="customUpload"
           
            >
            
            <!-- 选择图片按钮 -->
            <el-button class="upload-button" slot="trigger" size="small">
                <i class="el-icon-plus"></i>
            </el-button>
            
            <!-- 提示信息 -->
            <div slot="tip" class="el-upload__tip">{{ tipText }}</div>
        </el-upload>
          <!-- 图片列表 -->
        
        
    </div>
</template>

<script>
export default {
    name: 'FileUpload',
    props: {
        // 上传地址
        uploadUrl: {
            type: String,
            default: ''
        },
        // 接受的文件类型
        acceptTypes: {
            type: String,
            default: 'image/jpeg,image/jpg,image/png,image/gif,image/bmp'
        },
        // 选择按钮文字
        selectButtonText: {
            type: String,
            default: '选择图片'
        },
        // 提示文字
        tipText: {
            type: String,
            default: '支持上传JPG、JPEG、PNG、GIF、BMP格式的图片文件'
        },
        // 文件大小限制（MB）
        maxSize: {
            type: Number,
            default: 2
        },
        // 图片列表
        value: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            imageList: [...this.value],
            uploading: false,
            uploadingImage: null // 正在上传的图片
        }
    },
    watch: {
        value: {
            handler(newVal) {
                this.imageList = [...newVal];
            },
            deep: true
        }
    },
    methods: {
        // 文件上传前的验证
        beforeUpload(file) {
            const isImage = this.isImageFile(file);            
            if (!isImage) {
                this.$message.error('只能上传JPG、JPEG、PNG、GIF、BMP格式的图片文件！');
                return false;
            }            
            // 文件大小限制
            const isLtMaxSize = file.size / 1024 / 1024 < this.maxSize;
            if (!isLtMaxSize) {
                this.$message.error(`文件大小不能超过 ${this.maxSize}MB!`);
                return false;
            }            
            this.uploading = true;
            // 创建本地预览
            this.uploadingImage = {
                url: URL.createObjectURL(file),
                name: file.name
            };
            return true; // 允许上传
        },
        
        // 判断是否为图片文件
        isImageFile(file) {
            if (!file) return false;
            const imageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp'];
            return imageTypes.includes(file.type);
        },
        //自定义上传
        customUpload(options) {
            const formData = new FormData();
            formData.append('image', options.file);
            formData.append('username', this.$local.get('username'));
            formData.append('tid', this.$local.get('tid'));
            formData.append('category', 'product');

            fetch(this.uploadUrl, {
                method: 'POST',
                body: formData
            })
            .then(res => res.json())
            .then(response => {
                // console.log('手动上传成功:', response,options.file);
                this.uploadSuccess(response,options.file)
                options.onSuccess(response, options.file);
            })
            .catch(error => {
                console.error('手动上传失败:', error);
                options.onError(error);
            });
        },
        // 上传成功处理
        uploadSuccess(response, file, fileList) {
            this.uploading = false;
            this.uploadingImage = null; // 清除上传中的图片
            if (response.status === 1 && response.data && response.data.image_url) {
                // 添加图片到列表
                // const newImage = {
                //     product_image: response.data.image_url, // 使用file_url作为图片URL
                // };
                this.imageList.push(response.data.image_url);                
                this.$emit('input', this.imageList);
            } else {
                this.$message.error(response.msg || '上传失败！');
            }
        },
        
        // 上传失败处理
        handleUploadError(error, file, fileList) {
            this.uploading = false;
            this.uploadingImage = null; // 清除上传中的图片
            this.$message.error('图片上传失败！');
        },
        
        // 删除图片
        removeImage(index) {
            this.imageList.splice(index, 1);
            this.$emit('input', this.imageList);
        },
        
        handlePreview(file, fileList) {
            this.$emit('preview', file, fileList);
        },
                
        handleChange(file, fileList) {
            // 创建本地预览URL
            if (file.raw && this.isImageFile(file.raw)) {
                try {
                    file.url = URL.createObjectURL(file.raw);
                } catch (error) {
                    console.error('创建本地预览URL失败:', error);
                }
            }
        },
        
        // 清空图片列表
        clearImages() {
            this.imageList = [];
            this.$emit('input', this.imageList);
        },  
        // 设置图片列表
        setImageList(images) {
            this.imageList = images;
            this.$emit('input', this.imageList);
        },
      
        //查看大图
        showBigImg(image_url){
            this.$emit('showBigImg', image_url);
        }
    }
}
</script>

<style lang="scss" scoped>
.upload-button{
    align-items: center;
    background-color: #fafafa;
    border: 1px dashed #cdd0d6;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-flex;
    height: 148px;
    justify-content: center;
    vertical-align: top;
    width: 148px;
    color: #8c939d;
    font-size: 32px;
}
.image-upload-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
}

.image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 15px;
}

.image-item {
    position: relative;
    width: 148px;
    height: 148px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
    background-color: #fafafa;
}

.uploading-preview {
    margin-bottom: 15px;
}

.image-item.uploading {
    border-color: #409eff;
    background-color: #f0f9ff;
}

.uploading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 12px;
}

.uploading-overlay i {
    font-size: 20px;
    margin-bottom: 5px;
    animation: rotating 2s linear infinite;
}

@keyframes rotating {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.image-actions {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    // background-color: rgba(0, 0, 0, 0.5);
    // border-radius: 0 0 0 4px;
    // padding: 2px;
    &:hover{ 
        background: rgba(0, 0, 0, 0.5);
        .delete-btn-icon{
            display: block;
            
        }
    }
    .delete-btn-icon{
        display: none;
        font-size: 22px;
        color: white;
        cursor: pointer;
    }
}

.image-actions .el-button {
    padding: 4px;
    min-height: auto;
}

.upload-demo {
    /* width: 100%; */
}

.el-upload__tip {
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
}
</style>
